//loader
export const LOADER = {
    LOADER_TRIGGER: "loader-trigger",
    LOADER_SHOW: "loader-show",
  };
  
//Admin Get Profile
export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILE_REQUESTED = "GET_PROFILE_REQUESTED";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAILED = "GET_PROFILE_FAILED";

//Update Profile Action
export const GET_UPDATEPROFILE = "GET_UPDATEPROFILE";
export const GET_UPDATEPROFILE_REQUESTED = "GET_UPDATEPROFILE_REQUESTED";
export const GET_UPDATEPROFILE_SUCCESS = "GET_UPDATEPROFILE_SUCCESS";
export const GET_UPDATEPROFILE_FAILED = "GET_UPDATEPROFILE_FAILED";

//Login Action
export const GET_LOGIN = "GET_LOGIN";
export const GET_LOGIN_REQUESTED = "GET_LOGIN_REQUESTED";
export const GET_LOGIN_SUCCESS = "GET_LOGIN_SUCCESS";
export const GET_LOGIN_FAILED = "GET_LOGIN_FAILED";

//Otp Action
export const GET_OTP = "GET_OTP";
export const GET_OTP_REQUESTED = "GET_OTP_REQUESTED";
export const GET_OTP_SUCCESS = "GET_OTP_SUCCESS";
export const GET_OTP_FAILED = "GET_OTP_FAILED";

//Vendor Action
export const GET_VENDOR = "GET_VENDOR";
export const GET_VENDOR_REQUESTED = "GET_VENDOR_REQUESTED";
export const GET_VENDOR_SUCCESS = "GET_VENDOR_SUCCESS";
export const GET_VENDOR_FAILED = "GET_VENDOR_FAILED";

//Create Vendor Action
export const GET_ADDVENDOR = "GET_ADDVENDOR";
export const GET_ADDVENDOR_REQUESTED = "GET_ADDVENDOR_REQUESTED";
export const GET_ADDVENDOR_SUCCESS = "GET_ADDVENDOR_SUCCESS";
export const GET_ADDVENDOR_FAILED = "GET_ADDVENDOR_FAILED";

//Update Vendor Action
export const GET_UPDATEVENDOR = "GET_UPDATEVENDOR";
export const GET_UPDATEVENDOR_REQUESTED = "GET_UPDATEVENDOR_REQUESTED";
export const GET_UPDATEVENDOR_SUCCESS = "GET_UPDATEVENDOR_SUCCESS";
export const GET_UPDATEVENDOR_FAILED = "GET_UPDATEVENDOR_FAILED";

//Create Sub-Vendor Action
export const GET_SUBADDVENDOR = "GET_SUBADDVENDOR";
export const GET_SUBADDVENDOR_REQUESTED = "GET_SUBADDVENDOR_REQUESTED";
export const GET_SUBADDVENDOR_SUCCESS = "GET_SUBADDVENDOR_SUCCESS";
export const GET_SUBADDVENDOR_FAILED = "GET_SUBADDVENDOR_FAILED";

//Sub-Vendor Action
export const GET_SUBVENDOR = "GET_SUBVENDOR";
export const GET_SUBVENDOR_REQUESTED = "GET_SUBVENDOR_REQUESTED";
export const GET_SUBVENDOR_SUCCESS = "GET_SUBVENDOR_SUCCESS";
export const GET_SUBVENDOR_FAILED = "GET_SUBVENDOR_FAILED";


//Update Sub-Vendor Action
export const UPDATE_SUBADDVENDOR = "UPDATE_SUBADDVENDOR";
export const UPDATE_SUBADDVENDOR_REQUESTED = "UPDATE_SUBADDVENDOR_REQUESTED";
export const UPDATE_SUBADDVENDOR_SUCCESS = "UPDATE_SUBADDVENDOR_SUCCESS";
export const UPDATE_SUBADDVENDOR_FAILED = "UPDATE_SUBADDVENDOR_FAILED";

//More Details Sub-Vendor Action
export const GET_DETAILSUBVENDOR = "GET_DETAILSUBVENDOR";
export const GET_DETAILSUBVENDOR_REQUESTED = "GET_DETAILSUBVENDOR_REQUESTED";
export const GET_DETAILSUBVENDOR_SUCCESS = "GET_DETAILSUBVENDOR_SUCCESS";
export const GET_DETAILSUBVENDOR_FAILED = "GET_DETAILSUBVENDOR_FAILED";

//Compliance Action
export const GET_COMPLIANCE = "GET_COMPLIANCE";
export const GET_COMPLIANCE_REQUESTED = "GET_COMPLIANCE_REQUESTED";
export const GET_COMPLIANCE_SUCCESS = "GET_COMPLIANCE_SUCCESS";
export const GET_COMPLIANCE_FAILED = "GET_COMPLIANCE_FAILED";

//Config Compliance Action
export const GET_CONFIGCOMPLIANCE = "GET_CONFIGCOMPLIANCE";
export const GET_CONFIGCOMPLIANCE_REQUESTED = "GET_CONFIGCOMPLIANCE_REQUESTED";
export const GET_CONFIGCOMPLIANCE_SUCCESS = "GET_CONFIGCOMPLIANCE_SUCCESS";
export const GET_CONFIGCOMPLIANCE_FAILED = "GET_CONFIGCOMPLIANCE_FAILED";

//Approve Reject Compliance Action
export const GET_APPROVECOMPLIANCE = "GET_APPROVECOMPLIANCE";
export const GET_APPROVECOMPLIANCE_REQUESTED = "GET_APPROVECOMPLIANCE_REQUESTED";
export const GET_APPROVECOMPLIANCE_SUCCESS = "GET_APPROVECOMPLIANCE_SUCCESS";
export const GET_APPROVECOMPLIANCE_FAILED = "GET_APPROVECOMPLIANCE_FAILED";

//Create Config Compliance Action
export const GET_ADDCOMPLIANCE = "GET_ADDCOMPLIANCE";
export const GET_ADDCOMPLIANCE_REQUESTED = "GET_ADDCOMPLIANCE_REQUESTED";
export const GET_ADDCOMPLIANCE_SUCCESS = "GET_ADDCOMPLIANCE_SUCCESS";
export const GET_ADDCOMPLIANCE_FAILED = "GET_ADDCOMPLIANCE_FAILED";

//Update Config Compliance Action
export const GET_UPDATECOMPLIANCE = "GET_UPDATECOMPLIANCE";
export const GET_UPDATECOMPLIANCE_REQUESTED = "GET_UPDATECOMPLIANCE_REQUESTED";
export const GET_UPDATECOMPLIANCE_SUCCESS = "GET_UPDATECOMPLIANCE_SUCCESS";
export const GET_UPDATECOMPLIANCE_FAILED = "GET_UPDATECOMPLIANCE_FAILED";

//Onboard-Compliance Action
export const GET_ONBOARD_COMPLIANCE = "GET_ONBOARD_COMPLIANCE";
export const GET_ONBOARD_COMPLIANCE_REQUESTED = "GET_ONBOARD_COMPLIANCE_REQUESTED";
export const GET_ONBOARD_COMPLIANCE_SUCCESS = "GET_ONBOARD_COMPLIANCE_SUCCESS";
export const GET_ONBOARD_COMPLIANCE_FAILED = "GET_ONBOARD_COMPLIANCE_FAILED";

//Create Onboard-Compliance Action
export const GET_ADDONBOARD_COMPLIANCE = "GET_ADDONBOARD_COMPLIANCE";
export const GET_ADDONBOARD_COMPLIANCE_REQUESTED = "GET_ADDONBOARD_COMPLIANCE_REQUESTED";
export const GET_ADDONBOARD_COMPLIANCE_SUCCESS = "GET_ADDONBOARD_COMPLIANCE_SUCCESS";
export const GET_ADDONBOARD_COMPLIANCE_FAILED = "GET_ADDONBOARD_COMPLIANCE_FAILED";

//Driver Action
export const GET_DRIVER = "GET_DRIVER";
export const GET_DRIVER_REQUESTED = "GET_DRIVER_REQUESTED";
export const GET_DRIVER_SUCCESS = "GET_DRIVER_SUCCESS";
export const GET_DRIVER_FAILED = "GET_DRIVER_FAILED";
export const CLEAR_SELECTED_DRIVER = "CLEAR_SELECTED_DRIVER";

//Create Driver Action
export const GET_ADDDRIVER = "GET_ADDDRIVER";
export const GET_ADDDRIVER_REQUESTED = "GET_ADDDRIVER_REQUESTED";
export const GET_ADDDRIVER_SUCCESS = "GET_ADDDRIVER_SUCCESS";
export const GET_ADDDRIVER_FAILED = "GET_ADDDRIVER_FAILED";

//Update Driver Action
export const GET_UPDATEDRIVER = "GET_UPDATEDRIVER";
export const GET_UPDATEDRIVER_REQUESTED = "GET_UPDATEDRIVER_REQUESTED";
export const GET_UPDATEDRIVER_SUCCESS = "GET_UPDATEDRIVER_SUCCESS";
export const GET_UPDATEDRIVER_FAILED = "GET_UPDATEDRIVER_FAILED";

//FAQ Action
export const GET_FAQ = "GET_FAQ";
export const GET_FAQ_REQUESTED = "GET_FAQ_REQUESTED";
export const GET_FAQ_SUCCESS = "GET_FAQ_SUCCESS";
export const GET_FAQ_FAILED = "GET_FAQ_FAILED";

//Create FAQ Action
export const GET_ADDFAQ = "GET_ADDFAQ";
export const GET_ADDFAQ_REQUESTED = "GET_ADDFAQ_REQUESTED";
export const GET_ADDFAQ_SUCCESS = "GET_ADDFAQ_SUCCESS";
export const GET_ADDFAQ_FAILED = "GET_ADDFAQ_FAILED";

//Update FAQ Action
export const GET_UPDATEFAQ = "GET_UPDATEFAQ";
export const GET_UPDATEFAQ_REQUESTED = "GET_UPDATEFAQ_REQUESTED";
export const GET_UPDATEFAQ_SUCCESS = "GET_UPDATEFAQ_SUCCESS";
export const GET_UPDATEFAQ_FAILED = "GET_UPDATEFAQ_FAILED";

//Delete FAQ Action
export const GET_DELETEFAQ = "GET_DELETEFAQ";
export const GET_DELETEFAQ_REQUESTED = "GET_DELETEFAQ_REQUESTED";
export const GET_DELETEFAQ_SUCCESS = "GET_DELETEFAQ_SUCCESS";
export const GET_DELETEFAQ_FAILED = "GET_DELETEFAQ_FAILED";

//Car Action
export const GET_CAR = "GET_CAR";
export const GET_CAR_REQUESTED = "GET_CAR_REQUESTED";
export const GET_CAR_SUCCESS = "GET_CAR_SUCCESS";
export const GET_CAR_FAILED = "GET_CAR_FAILED";

//Create Car Action
export const GET_ADDCAR = "GET_ADDCAR";
export const GET_ADDCAR_REQUESTED = "GET_ADDCAR_REQUESTED";
export const GET_ADDCAR_SUCCESS = "GET_ADDCAR_SUCCESS";
export const GET_ADDCAR_FAILED = "GET_ADDCAR_FAILED";

//Update Car Action
export const GET_UPDATECAR = "GET_UPDATECAR";
export const GET_UPDATECAR_REQUESTED = "GET_UPDATECAR_REQUESTED";
export const GET_UPDATECAR_SUCCESS = "GET_UPDATECAR_SUCCESS";
export const GET_UPDATECAR_FAILED = "GET_UPDATECAR_FAILED";

//Delete Car Action
export const GET_DELETECAR = "GET_DELETECAR";
export const GET_DELETECAR_REQUESTED = "GET_DELETECAR_REQUESTED";
export const GET_DELETECAR_SUCCESS = "GET_DELETECAR_SUCCESS";
export const GET_DELETECAR_FAILED = "GET_DELETECAR_FAILED";

//Facilities Action
export const GET_FACILITIES = "GET_FACILITIES";
export const GET_FACILITIES_REQUESTED = "GET_FACILITIES_REQUESTED";
export const GET_FACILITIES_SUCCESS = "GET_FACILITIES_SUCCESS";
export const GET_FACILITIES_FAILED = "GET_FACILITIES_FAILED";

//Tag Action
export const GET_TAG = "GET_TAG";
export const GET_TAG_REQUESTED = "GET_TAG_REQUESTED";
export const GET_TAG_SUCCESS = "GET_TAG_SUCCESS";
export const GET_TAG_FAILED = "GET_TAG_FAILED";

//Create Tag Action
export const GET_ADDTAG = "GET_ADDTAG";
export const GET_ADDTAG_REQUESTED = "GET_ADDTAG_REQUESTED";
export const GET_ADDTAG_SUCCESS = "GET_ADDTAG_SUCCESS";
export const GET_ADDTAG_FAILED = "GET_ADDTAG_FAILED";

//Update Tag Action
export const GET_UPDATETAG = "GET_UPDATETAG";
export const GET_UPDATETAG_REQUESTED = "GET_UPDATETAG_REQUESTED";
export const GET_UPDATETAG_SUCCESS = "GET_UPDATETAG_SUCCESS";
export const GET_UPDATETAG_FAILED = "GET_UPDATETAG_FAILED";

//Rating Action
export const GET_RATING = "GET_RATING";
export const GET_RATING_REQUESTED = "GET_RATING_REQUESTED";
export const GET_RATING_SUCCESS = "GET_RATING_SUCCESS";
export const GET_RATING_FAILED = "GET_RATING_FAILED";

// Dashboard Ride Details
export const GET_RIDE = "GET_RIDE";
export const GET_RIDE_REQUESTED = "GET_RIDE_REQUESTED";
export const GET_RIDE_SUCCESS = "GET_RIDE_SUCCESS";
export const GET_RIDE_FAILED = "GET_RIDE_FAILED";

// Dashboard Total Registration
export const GET_TOTALREGISTRATION = "GET_TOTALREGISTRATION";
export const GET_TOTALREGISTRATION_REQUESTED = "GET_TOTALREGISTRATION_REQUESTED";
export const GET_TOTALREGISTRATION_SUCCESS = "GET_TOTALREGISTRATION_SUCCESS";
export const GET_TOTALREGISTRATION_FAILED = "GET_TOTALREGISTRATION_FAILED";

// Dashboard Daily Customer
export const GET_DAILYCUSTOMER = "GET_DAILYCUSTOMER";
export const GET_DAILYCUSTOMER_REQUESTED = "GET_DAILYCUSTOMER_REQUESTED";
export const GET_DAILYCUSTOMER_SUCCESS = "GET_DAILYCUSTOMER_SUCCESS";
export const GET_DAILYCUSTOMER_FAILED = "GET_DAILYCUSTOMER_FAILED";

// Dashboard Daily Ride
export const GET_RIDEANALYTIC = "GET_RIDEANALYTIC";
export const GET_RIDEANALYTIC_REQUESTED = "GET_RIDEANALYTIC_REQUESTED";
export const GET_RIDEANALYTIC_SUCCESS = "GET_RIDEANALYTIC_SUCCESS";
export const GET_RIDEANALYTIC_FAILED = "GET_RIDEANALYTIC_FAILED";

// Customer Action
export const GET_CUSTOMER = "GET_CUSTOMER";
export const GET_CUSTOMER_REQUESTED = "GET_CUSTOMER_REQUESTED";
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_FAILED = "GET_CUSTOMER_FAILED";

// customer Compalints Action
export const GET_CUSTOMER_COMPLAINTS = "GET_CUSTOMER_COMPLAINTS";
export const GET_CUSTOMER_COMPLAINTS_REQUESTED = "GET_CUSTOMER_COMPLAINTS_REQUESTED";
export const GET_CUSTOMER_COMPLAINTS_SUCCESS = "GET_CUSTOMER_COMPLAINTS_SUCCESS";
export const GET_CUSTOMER_COMPLAINTS_FAILED = "GET_CUSTOMER_COMPLAINTS_FAILED";

// Update Complaint Action
export const UPDATE_COMPLAINT = "UPDATE_COMPLAINT";
export const UPDATE_COMPLAINT_REQUESTED = "UPDATE_COMPLAINT_REQUESTED";
export const UPDATE_COMPLAINT_SUCCESS = "UPDATE_COMPLAINT_SUCCESS";
export const UPDATE_COMPLAINT_FAILED = "UPDATE_COMPLAINT_FAILED";

// Update Customer Action
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const UPDATE_CUSTOMER_REQUESTED = "UPDATE_CUSTOMER_REQUESTED";
export const UPDATE_CUSTOMER_SUCCESS = "UPDATE_CUSTOMER_SUCCESS";
export const UPDATE_CUSTOMER_FAILED = "UPDATE_CUSTOMER_FAILED";

//Customer Matrix Action
export const GET_MATRIXCUSTOMER = "GET_MATRIXCUSTOMER";
export const GET_MATRIXCUSTOMER_REQUESTED = "GET_MATRIXCUSTOMER_REQUESTED";
export const GET_MATRIXCUSTOMER_SUCCESS = "GET_MATRIXCUSTOMER_SUCCESS";
export const GET_MATRIXCUSTOMER_FAILED = "GET_MATRIXCUSTOMER_FAILED";

//Customer Ticket Action
export const GET_TICKETCUSTOMER = "GET_TICKETCUSTOMER";
export const GET_TICKETCUSTOMER_REQUESTED = "GET_TICKETCUSTOMER_REQUESTED";
export const GET_TICKETCUSTOMER_SUCCESS = "GET_TICKETCUSTOMER_SUCCESS";
export const GET_TICKETCUSTOMER_FAILED = "GET_TICKETCUSTOMER_FAILED";

//Driver Matrix Action
export const GET_MATRIXDRIVER = "GET_MATRIXDRIVER";
export const GET_MATRIXDRIVER_REQUESTED = "GET_MATRIXDRIVER_REQUESTED";
export const GET_MATRIXDRIVER_SUCCESS = "GET_MATRIXDRIVER_SUCCESS";
export const GET_MATRIXDRIVER_FAILED = "GET_MATRIXDRIVER_FAILED";

//Driver Ticket Action
export const GET_TICKETDRIVER = "GET_TICKETDRIVER";
export const GET_TICKETDRIVER_REQUESTED = "GET_TICKETDRIVER_REQUESTED";
export const GET_TICKETDRIVER_SUCCESS = "GET_TICKETDRIVER_SUCCESS";
export const GET_TICKETDRIVER_FAILED = "GET_TICKETDRIVER_FAILED";

//Driver More Details Action
export const GET_MOREDRIVER = "GET_MOREDRIVER";
export const GET_MOREDRIVER_REQUESTED = "GET_MOREDRIVER_REQUESTED";
export const GET_MOREDRIVER_SUCCESS = "GET_MOREDRIVER_SUCCESS";
export const GET_MOREDRIVER_FAILED = "GET_MOREDRIVER_FAILED";

//FAQ Section Action
export const GET_FAQ_SECTION = "GET_FAQ_SECTION";
export const GET_FAQ_SECTION_REQUESTED = "GET_FAQ_SECTION_REQUESTED";
export const GET_FAQ_SECTION_SUCCESS = "GET_FAQ_SECTION_SUCCESS";
export const GET_FAQ_SECTION_FAILED = "GET_FAQ_SECTION_FAILED";
//Vehicle Action
export const GET_VEHICLE = "GET_VEHICLE";
export const GET_VEHICLE_REQUESTED = "GET_VEHICLE_REQUESTED";
export const GET_VEHICLE_SUCCESS = "GET_VEHICLE_SUCCESS";
export const GET_VEHICLE_FAILED = "GET_VEHICLE_FAILED";

//Create Vehicle Action
export const GET_ADDVEHICLE = "GET_ADDVEHICLE";
export const GET_ADDVEHICLE_REQUESTED = "GET_ADDVEHICLE_REQUESTED";
export const GET_ADDVEHICLE_SUCCESS = "GET_ADDVEHICLE_SUCCESS";
export const GET_ADDVEHICLE_FAILED = "GET_ADDVEHICLE_FAILED";

//Update Vehicle Action
export const GET_UPDATEVEHICLE = "GET_UPDATEVEHICLE";
export const GET_UPDATEVEHICLE_REQUESTED = "GET_UPDATEVEHICLE_REQUESTED";
export const GET_UPDATEVEHICLE_SUCCESS = "GET_UPDATEVEHICLE_SUCCESS";
export const GET_UPDATEVEHICLE_FAILED = "GET_UPDATEVEHICLE_FAILED";

//Delete VEHICLE Action
export const GET_DELETEVEHICLE = "GET_DELETEVEHICLE";
export const GET_DELETEVEHICLE_REQUESTED = "GET_DELETEVEHICLE_REQUESTED";
export const GET_DELETEVEHICLE_SUCCESS = "GET_DELETEVEHICLE_SUCCESS";
export const GET_DELETEVEHICLE_FAILED = "GET_DELETEVEHICLE_FAILED";

//Our Car Action
export const GET_OURCAR = "GET_OURCAR";
export const GET_OURCAR_REQUESTED = "GET_OURCAR_REQUESTED";
export const GET_OURCAR_SUCCESS = "GET_OURCAR_SUCCESS";
export const GET_OURCAR_FAILED = "GET_OURCAR_FAILED";

//Cab Ride Details Action
export const GET_CABRIDE = "GET_CABRIDE";
export const GET_CABRIDE_REQUESTED = "GET_CABRIDE_REQUESTED";
export const GET_CABRIDE_SUCCESS = "GET_CABRIDE_SUCCESS";
export const GET_CABRIDE_FAILED = "GET_CABRIDE_FAILED";

//Top Vendor Action
export const GET_TOPVENDOR = "GET_TOPVENDOR";
export const GET_TOPVENDOR_REQUESTED = "GET_TOPVENDOR_REQUESTED";
export const GET_TOPVENDOR_SUCCESS = "GET_TOPVENDOR_SUCCESS";
export const GET_TOPVENDOR_FAILED = "GET_TOPVENDOR_FAILED";

//Top Sub Vendor Action
export const GET_TOPSUBVENDOR = "GET_TOPSUBVENDOR";
export const GET_TOPSUBVENDOR_REQUESTED = "GET_TOPSUBVENDOR_REQUESTED";
export const GET_TOPSUBVENDOR_SUCCESS = "GET_TOPSUBVENDOR_SUCCESS";
export const GET_TOPSUBVENDOR_FAILED = "GET_TOPSUBVENDOR_FAILED";

//Top Driver Action
export const GET_TOPDRIVER = "GET_TOPDRIVER";
export const GET_TOPDRIVER_REQUESTED = "GET_TOPDRIVER_REQUESTED";
export const GET_TOPDRIVER_SUCCESS = "GET_TOPDRIVER_SUCCESS";
export const GET_TOPDRIVER_FAILED = "GET_TOPDRIVER_FAILED";

//Ride Acceptance Action
export const GET_RIDEACCEPT = "GET_RIDEACCEPT";
export const GET_RIDEACCEPT_REQUESTED = "GET_RIDEACCEPT_REQUESTED";
export const GET_RIDEACCEPT_SUCCESS = "GET_RIDEACCEPT_SUCCESS";
export const GET_RIDEACCEPT_FAILED = "GET_RIDEACCEPT_FAILED";

//Dashboard Feedback Action
export const GET_DASHBOARDFEEDBACK = "GET_DASHBOARDFEEDBACK";
export const GET_DASHBOARDFEEDBACK_REQUESTED = "GET_DASHBOARDFEEDBACK_REQUESTED";
export const GET_DASHBOARDFEEDBACK_SUCCESS = "GET_DASHBOARDFEEDBACK_SUCCESS";
export const GET_DASHBOARDFEEDBACK_FAILED = "GET_DASHBOARDFEEDBACK_FAILED";

// Trip Action
export const GET_TRIP = "GET_TRIP";
export const GET_TRIP_REQUESTED = "GET_TRIP_REQUESTED";
export const GET_TRIP_SUCCESS = "GET_TRIP_SUCCESS";
export const GET_TRIP_FAILED = "GET_TRIP_FAILED";
export const CLEAR_SELECTED_TRIP = "CLEAR_SELECTED_TRIP";

// Invoice Details Action
export const GET_INVOICE = "GET_INVOICE";
export const GET_INVOICE_REQUESTED = "GET_INVOICE_REQUESTED";
export const GET_INVOICE_SUCCESS = "GET_INVOICE_SUCCESS";
export const GET_INVOICE_FAILED = "GET_INVOICE_FAILED";

// InvoiceDownlod Details Action
export const GET_INVOICE_DOWNLOAD = "GET_INVOICE_DOWNLOAD";
export const GET_INVOICE_DOWNLOAD_REQUESTED = "GET_INVOICE_DOWNLOAD_REQUESTED";
export const GET_INVOICE_DOWNLOAD_SUCCESS = "GET_INVOICE_DOWNLOAD_SUCCESS";
export const GET_INVOICE_DOWNLOAD_FAILED = "GET_INVOICE_DOWNLOAD_FAILED";

// Cancel Trip Action
export const GET_CANCEL_TRIP = "GET_CANCEL_TRIP";
export const GET_CANCEL_TRIP_REQUESTED = "GET_CANCEL_TRIP_REQUESTED";
export const GET_CANCEL_TRIP_SUCCESS = "GET_CANCEL_TRIP_SUCCESS";
export const GET_CANCEL_TRIP_FAILED = "GET_CANCEL_TRIP_FAILED";

//SOS Action
export const GET_SOS_ALERT = "GET_SOS_ALERT";
export const GET_SOS_ALERT_REQUESTED = "GET_SOS_ALERT_REQUESTED";
export const GET_SOS_ALERT_SUCCESS = "GET_SOS_ALERT_SUCCESS";
export const GET_SOS_ALERT_FAILED = "GET_SOS_ALERT_FAILED";

// Notification Action
export const GET_NOTIFICATION = "GET_NOTIFICATION";
export const GET_NOTIFICATION_REQUESTED = "GET_NOTIFICATION_REQUESTED";
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_FAILED = "GET_NOTIFICATION_FAILED";

// Notification Count Action
export const GET_NOTIFICATIONCOUNT = "GET_NOTIFICATIONCOUNT";
export const GET_NOTIFICATIONCOUNT_REQUESTED = "GET_NOTIFICATIONCOUNT_REQUESTED";
export const GET_NOTIFICATIONCOUNT_SUCCESS = "GET_NOTIFICATIONCOUNT_SUCCESS";
export const GET_NOTIFICATIONCOUNT_FAILED = "GET_NOTIFICATIONCOUNT_FAILED";

// Notification Seen Action
export const GET_NOTIFICATIONSEEN = "GET_NOTIFICATIONSEEN";
export const GET_NOTIFICATIONSEEN_REQUESTED = "GET_NOTIFICATIONSEEN_REQUESTED";
export const GET_NOTIFICATIONSEEN_SUCCESS = "GET_NOTIFICATIONSEEN_SUCCESS";
export const GET_NOTIFICATIONSEEN_FAILED = "GET_NOTIFICATIONSEEN_FAILED";

// Request Assign Vehicle Action
export const GET_REQUESTVEHICLE = "GET_REQUESTVEHICLE";
export const GET_REQUESTVEHICLE_REQUESTED = "GET_REQUESTVEHICLE_REQUESTED";
export const GET_REQUESTVEHICLE_SUCCESS = "GET_REQUESTVEHICLE_SUCCESS";
export const GET_REQUESTVEHICLE_FAILED = "GET_REQUESTVEHICLE_FAILED";

// Assigned Vehicle Action
export const GET_LISTASSIGNEDVEHICLE = "GET_LISTASSIGNEDVEHICLE";
export const GET_LISTASSIGNEDVEHICLE_REQUESTED = "GET_LISTASSIGNEDVEHICLE_REQUESTED";
export const GET_LISTASSIGNEDVEHICLE_SUCCESS = "GET_LISTASSIGNEDVEHICLE_SUCCESS";
export const GET_LISTASSIGNEDVEHICLE_FAILED = "GET_LISTASSIGNEDVEHICLE_FAILED";

// List of Drivers Vehicle Action
export const GET_ASSIGNVEHICLE = "GET_ASSIGNVEHICLE";
export const GET_ASSIGNVEHICLE_REQUESTED = "GET_ASSIGNVEHICLE_REQUESTED";
export const GET_ASSIGNVEHICLE_SUCCESS = "GET_ASSIGNVEHICLE_SUCCESS";
export const GET_ASSIGNVEHICLE_FAILED = "GET_ASSIGNVEHICLE_FAILED";

// Update Assign Vehicle Action
export const GET_UPDATEASSIGNVEHICLE = "GET_UPDATEASSIGNVEHICLE";
export const GET_UPDATEASSIGNVEHICLE_REQUESTED = "GET_UPDATEASSIGNVEHICLE_REQUESTED";
export const GET_UPDATEASSIGNVEHICLE_SUCCESS = "GET_UPDATEASSIGNVEHICLE_SUCCESS";
export const GET_UPDATEASSIGNVEHICLE_FAILED = "GET_UPDATEASSIGNVEHICLE_FAILED";

//Update Assign Driver Action
export const GET_UPDATEASSIGNDRIVER = "GET_UPDATEASSIGNDRIVER";
export const GET_UPDATEASSIGNDRIVER_REQUESTED = "GET_UPDATEASSIGNDRIVER_REQUESTED";
export const GET_UPDATEASSIGNDRIVER_SUCCESS = "GET_UPDATEASSIGNDRIVER_SUCCESS";
export const GET_UPDATEASSIGNDRIVER_FAILED = "GET_UPDATEASSIGNDRIVER_FAILED";

//Update Assign SubVendor Action
export const GET_UPDATEASSIGNSUBVENDOR = "GET_UPDATEASSIGNSUBVENDOR";
export const GET_UPDATEASSIGNSUBVENDOR_REQUESTED = "GET_UPDATEASSIGNSUBVENDOR_REQUESTED";
export const GET_UPDATEASSIGNSUBVENDOR_SUCCESS = "GET_UPDATEASSIGNSUBVENDOR_SUCCESS";
export const GET_UPDATEASSIGNSUBVENDOR_FAILED = "GET_UPDATEASSIGNSUBVENDOR_FAILED";

//Choose Your Service Action
export const GET_CHOOSEYOURSERVICE = "GET_CHOOSEYOURSERVICE";
export const GET_CHOOSEYOURSERVICE_REQUESTED = "GET_CHOOSEYOURSERVICE_REQUESTED";
export const GET_CHOOSEYOURSERVICE_SUCCESS = "GET_CHOOSEYOURSERVICE_SUCCESS";
export const GET_CHOOSEYOURSERVICE_FAILED = "GET_CHOOSEYOURSERVICE_FAILED";

//Create Choose Your Service Action
export const GET_ADDCHOOSEYOURSERVICE = "GET_ADDCHOOSEYOURSERVICE";
export const GET_ADDCHOOSEYOURSERVICE_REQUESTED = "GET_ADDCHOOSEYOURSERVICE_REQUESTED";
export const GET_ADDCHOOSEYOURSERVICE_SUCCESS = "GET_ADDCHOOSEYOURSERVICE_SUCCESS";
export const GET_ADDCHOOSEYOURSERVICE_FAILED = "GET_ADDCHOOSEYOURSERVICE_FAILED";

//Update Choose Your Service Action
export const GET_UPDATECHOOSEYOURSERVICE = "GET_UPDATECHOOSEYOURSERVICE";
export const GET_UPDATECHOOSEYOURSERVICE_REQUESTED = "GET_UPDATECHOOSEYOURSERVICE_REQUESTED";
export const GET_UPDATECHOOSEYOURSERVICE_SUCCESS = "GET_UPDATECHOOSEYOURSERVICE_SUCCESS";
export const GET_UPDATECHOOSEYOURSERVICE_FAILED = "GET_UPDATECHOOSEYOURSERVICE_FAILED";

//Vehicle Matrix Action
export const GET_MATRIXVEHICLE = "GET_MATRIXVEHICLE";
export const GET_MATRIXVEHICLE_REQUESTED = "GET_MATRIXVEHICLE_REQUESTED";
export const GET_MATRIXVEHICLE_SUCCESS = "GET_MATRIXVEHICLE_SUCCESS";
export const GET_MATRIXVEHICLE_FAILED = "GET_MATRIXVEHICLE_FAILED";

//Vehicle More Details Action
export const GET_MOREVEHICLE = "GET_MOREVEHICLE";
export const GET_MOREVEHICLE_REQUESTED = "GET_MOREVEHICLE_REQUESTED";
export const GET_MOREVEHICLE_SUCCESS = "GET_MOREVEHICLE_SUCCESS";
export const GET_MOREVEHICLE_FAILED = "GET_MOREVEHICLE_FAILED";

//Get Rate Card Action
export const GET_RATECARD = "GET_RATECARD"
export const GET_RATECARD_REQUESTED = "GET_RATECARD_REQUESTED"
export const GET_RATECARD_SUCCESS = "GET_RATECARD_SUCCESS"
export const GET_RATECARD_FAILED = "GET_RATECARD_FAILED"

//Add Rate Card Action
export const GET_ADDRATECARD = "GET_ADDRATECARD"
export const GET_ADDRATECARD_REQUESTED = "GET_ADDRATECARD_REQUESTED"
export const GET_ADDRATECARD_SUCCESS = "GET_ADDRATECARD_SUCCESS"
export const GET_ADDRATECARD_FAILED = "GET_ADDRATECARD_FAILED"
 
// Add Service City Action
export const GET_SERVICECITY = "GET_SERVICECITY"
export const GET_SERVICECITY_REQUESTED = "GET_SERVICECITY_REQUESTED"
export const GET_SERVICECITY_SUCCESS = "GET_SERVICECITY_SUCCESS"
export const GET_SERVICECITY_FAILED = "GET_SERVICECITY_FAILED"

// Service Region Action
export const GET_SERVICEREGION = "GET_SERVICEREGION"
export const GET_SERVICEREGION_REQUESTED = "GET_SERVICEREGION_REQUESTED"
export const GET_SERVICEREGION_SUCCESS = "GET_SERVICEREGION_SUCCESS"
export const GET_SERVICEREGION_FAILED = "GET_SERVICEREGION_FAILED"

//Add Service Region Action
export const GET_ADDSERVICEREGION = "GET_ADDSERVICEREGION";
export const GET_ADDSERVICEREGION_REQUESTED = "GET_ADDSERVICEREGION_REQUESTED";
export const GET_ADDSERVICEREGION_SUCCESS = "GET_ADDSERVICEREGION_SUCCESS";
export const GET_ADDSERVICEREGION_FAILED = "GET_ADDSERVICEREGION_FAILED";

//Create Sub-vendor Region Action
export const GET_SUBVENDORREGION = "GET_SUBVENDORREGION";
export const GET_SUBVENDORREGION_REQUESTED = "GET_SUBVENDORREGION_REQUESTED";
export const GET_SUBVENDORREGION_SUCCESS = "GET_SUBVENDORREGION_SUCCESS";
export const GET_SUBVENDORREGION_FAILED = "GET_SUBVENDORREGION_FAILED";

//Add sub-vendor Region Action
export const GET_ADDSUBVENDORREGION = "GET_ADDSUBVENDORREGION";
export const GET_ADDSUBVENDORREGION_REQUESTED = "GET_ADDSUBVENDORREGION_REQUESTED";
export const GET_ADDSUBVENDORREGION_SUCCESS = "GET_ADDSUBVENDORREGION_SUCCESS";
export const GET_ADDSUBVENDORREGION_FAILED = "GET_ADDSUBVENDORREGION_FAILED";

//Get Vendor user Action
export const GET_VENDORUSER = "GET_VENDORUSER";
export const GET_VENDORUSER_REQUESTED = "GET_VENDORUSER_REQUESTED";
export const GET_VENDORUSER_SUCCESS = "GET_VENDORUSER_SUCCESS";
export const GET_VENDORUSER_FAILED = "GET_VENDORUSER_FAILED";

//Logout Action
export const GET_LOGOUT = "GET_LOGOUT";
export const GET_LOGOUT_REQUESTED = "GET_LOGOUT_REQUESTED";
export const GET_LOGOUT_SUCCESS = "GET_LOGOUT_SUCCESS";
export const GET_LOGOUT_FAILURE = "GET_LOGOUT_FAILURE";

//Get Assign Driver Action
export const GET_ASSIGN_DRIVER = "GET_ASSIGN_DRIVER";
export const GET_ASSIGN_DRIVER_REQUESTED = "GET_ASSIGN_DRIVER_REQUESTED";
export const GET_ASSIGN_DRIVER_SUCCESS = "GET_ASSIGN_DRIVER_SUCCESS";
export const GET_ASSIGN_DRIVER_FAILED = "GET_ASSIGN_DRIVER_FAILED";

//Get Booking Action
export const GET_BOOKING = "GET_BOOKING";
export const GET_BOOKING_REQUESTED = "GET_BOOKING_REQUESTED";
export const GET_BOOKING_SUCCESS = "GET_BOOKING_SUCCESS";
export const GET_BOOKING_FAILED = "GET_BOOKING_FAILED";

//Get Revenue Action
export const GET_REVENUE = "GET_REVENUE";
export const GET_REVENUE_REQUESTED = "GET_REVENUE_REQUESTED";
export const GET_REVENUE_SUCCESS = "GET_REVENUE_SUCCESS";
export const GET_REVENUE_FAILED = "GET_REVENUE_FAILED";

//Get Revenue-Matrix Action
export const GET_REVENUE_MATRIX = "GET_REVENUE_MATRIX";
export const GET_REVENUE_MATRIX_REQUESTED = "GET_REVENUE_MATRIX_REQUESTED";
export const GET_REVENUE_MATRIX_SUCCESS = "GET_REVENUE_MATRIX_SUCCESS";
export const GET_REVENUE_MATRIX_FAILED = "GET_REVENUE_MATRIX_FAILED";

//Get Revenue-Export Action
export const GET_REVENUE_EXPORT = "GET_REVENUE_EXPORT";
export const GET_REVENUE_EXPORT_REQUESTED = "GET_REVENUE_EXPORT_REQUESTED";
export const GET_REVENUE_EXPORT_SUCCESS = "GET_REVENUE_EXPORT_SUCCESS";
export const GET_REVENUE_EXPORT_FAILED = "GET_REVENUE_EXPORT_FAILED";

//Get Customer-Matrix Action
export const GET_CUSTOMER_MATRIX = "GET_CUSTOMER_MATRIX";
export const GET_CUSTOMER_MATRIX_REQUESTED = "GET_CUSTOMER_MATRIX_REQUESTED";
export const GET_CUSTOMER_MATRIX_SUCCESS = "GET_CUSTOMER_MATRIX_SUCCESS";
export const GET_CUSTOMER_MATRIX_FAILED = "GET_CUSTOMER_MATRIX_FAILED";

//Get Base Fuel Action
export const GET_BASE_FUEL = "GET_BASE_FUEL";
export const GET_BASE_FUEL_REQUESTED = "GET_BASE_FUEL_REQUESTED";
export const GET_BASE_FUEL_SUCCESS = "GET_BASE_FUEL_SUCCESS";
export const GET_BASE_FUEL_FAILED = "GET_BASE_FUEL_FAILED";

//Magic Token Action
export const GET_MAGICTOKEN = "GET_MAGICTOKEN";
export const GET_MAGICTOKEN_REQUESTED = "GET_MAGICTOKEN_REQUESTED";
export const GET_MAGICTOKEN_SUCCESS = "GET_MAGICTOKEN_SUCCESS";
export const GET_MAGICTOKEN_FAILED = "GET_MAGICTOKEN_FAILED";

//Magic Token Verifiy Action
export const GET_TOKENVERIFY = "GET_TOKENVERIFY";
export const GET_TOKENVERIFY_REQUESTED = "GET_TOKENVERIFY_REQUESTED";
export const GET_TOKENVERIFY_SUCCESS = "GET_TOKENVERIFY_SUCCESS";
export const GET_TOKENVERIFY_FAILED = "GET_TOKENVERIFY_FAILED";

//Roles and permissions
export const GET_ROLESANDPERMISSIONS = {
  GET_ROLESANDPERMISSIONS_REQUESTED: "GET_ROLESANDPERMISSIONS_REQUESTED",
  GET_ROLESANDPERMISSIONS_SUCCESS: "GET_ROLESANDPERMISSIONS_SUCCESS",
  GET_ROLESANDPERMISSIONS_FAILED: "GET_ROLESANDPERMISSIONS_FAILED",
};

//Roles and permissions
export const GET_SUPPLIERROLE = {
  GET_SUPPLIERROLE_REQUESTED: "GET_SUPPLIERROLE_REQUESTED",
  GET_SUPPLIERROLE_SUCCESS: "GET_SUPPLIERROLE_SUCCESS",
  GET_SUPPLIERROLE_FAILED: "GET_SUPPLIERROLE_FAILED",
};

//Coupon Action
export const GET_COUPON = "GET_COUPON";
export const GET_COUPON_REQUESTED = "GET_COUPON_REQUESTED";
export const GET_COUPON_SUCCESS = "GET_COUPON_SUCCESS";
export const GET_COUPON_FAILED = "GET_COUPON_FAILED";

//Create Coupon Action
export const GET_ADDCOUPON = "GET_ADDCOUPON";
export const GET_ADDCOUPON_REQUESTED = "GET_ADDCOUPON_REQUESTED";
export const GET_ADDCOUPON_SUCCESS = "GET_ADDCOUPON_SUCCESS";
export const GET_ADDCOUPON_FAILED = "GET_ADDCOUPON_FAILED";

//Update Coupon Action
export const GET_UPDATECOUPON = "GET_UPDATECOUPON";
export const GET_UPDATECOUPON_REQUESTED = "GET_UPDATECOUPON_REQUESTED";
export const GET_UPDATECOUPON_SUCCESS = "GET_UPDATECOUPON_SUCCESS";
export const GET_UPDATECOUPON_FAILED = "GET_UPDATECOUPON_FAILED";

//Delete Coupon Action
export const GET_DELETECOUPON = "GET_DELETECOUPON";
export const GET_DELETECOUPON_REQUESTED = "GET_DELETECOUPON_REQUESTED";
export const GET_DELETECOUPON_SUCCESS = "GET_DELETECOUPON_SUCCESS";
export const GET_DELETECOUPON_FAILED = "GET_DELETECOUPON_FAILED";

// Live Data
export const GET_RIDEDETAILSPOLYLINE = {
  GET_RIDEDETAILSPOLYLINE_REQUESTED: "GET_RIDEDETAILSPOLYLINE_REQUESTED",
  GET_RIDEDETAILSPOLYLINE_SUCCESS: "GET_RIDEDETAILSPOLYLINE_SUCCESS",
  GET_RIDEDETAILSPOLYLINE_FAILED: "GET_RIDEDETAILSPOLYLINE_FAILED",
};

//Operation
export const GET_ALLOTVEHICLE = {
  GET_ALLOTVEHICLE_REQUESTED: "GET_ALLOTVEHICLE_REQUESTED",
  GET_ALLOTVEHICLE_SUCCESS: "GET_ALLOTVEHICLE_SUCCESS",
  GET_ALLOTVEHICLE_FAILED: "GET_ALLOTVEHICLE_FAILED",
};

export const GET_AVAILABLEVEHICLE = {
  GET_AVAILABLEVEHICLE_REQUESTED: "GET_AVAILABLEVEHICLE_REQUESTED",
  GET_AVAILABLEVEHICLE_SUCCESS: "GET_AVAILABLEVEHICLE_SUCCESS",
  GET_AVAILABLEVEHICLE_FAILED: "GET_AVAILABLEVEHICLE_FAILED",
  GET_AVAILABLEVEHICLE_CLEAR: "GET_AVAILABLEVEHICLE_CLEAR",

};

export const GET_AVAILABLESUPPLIERS = {
  GET_AVAILABLESUPPLIERS_REQUESTED: "GET_AVAILABLESUPPLIERS_REQUESTED",
  GET_AVAILABLESUPPLIERS_SUCCESS: "GET_AVAILABLESUPPLIERS_SUCCESS",
  GET_AVAILABLESUPPLIERS_FAILED: "GET_AVAILABLESUPPLIERS_FAILED",
  GET_AVAILABLESUPPLIERS_CLEAR: "GET_AVAILABLESUPPLIERS_CLEAR",
};


//migrated ActionTypes

// Get complince Regex validation 
export const GET_COPMLIANCEVALIDATION = {
  GET_COPMLIANCEVALIDATION_REQUESTED: "GET_COPMLIANCEVALIDATION_REQUESTED",
  GET_COPMLIANCEVALIDATION_SUCCESS: "GET_COPMLIANCEVALIDATION_SUCCESS",
  GET_COPMLIANCEVALIDATION_FAILED: "GET_COPMLIANCEVALIDATION_FAILED",
}

//Trip Action
// export const GET_TRIP = "GET_TRIP";
// export const GET_TRIP_REQUESTED = "GET_TRIP_REQUESTED";
// export const GET_TRIP_SUCCESS = "ET_TRIP_SUCCESS";
// export const GET_TRIP_FAILED = "GET_TRIP_FAILED";

//ShareTrip Action
export const GET_SHARE_TRIP = "GET_SHARE_TRIP";
export const GET_SHARE_TRIP_REQUESTED = "GET_SHARE_TRIP_REQUESTED";
export const GET_SHARE_TRIP_SUCCESS = "GET_SHARE_TRIP_SUCCESS";
export const GET_SHARE_TRIP_FAILED = "GET_SHARE_TRIP_FAILED";

//Google Map AutoComplete
export const GET_GOOGLE_MAP_AUTOCOMPLETE = "GET_GOOGLE_MAP_AUTOCOMPLETE";
export const GET_GOOGLE_MAP_AUTOCOMPLETE_REQUESTED ="GET_GOOGLE_MAP_AUTOCOMPLETE_REQUESTED";
export const GET_GOOGLE_MAP_AUTOCOMPLETE_SUCCESS = "GET_GOOGLE_MAP_AUTOCOMPLETE_SUCCESS";
export const GET_GOOGLE_MAP_AUTOCOMPLETE_FAILED = "GET_GOOGLE_MAP_AUTOCOMPLETE_FAILED"

//Google Map NearBySearch
export const GET_GOOGLE_NEARBY_SEARCH = "GET_GOOGLE_NEARBY_SEARCH ";
export const GET_GOOGLE_NEARBY_SEARCH_REQUESTED ="GET_GOOGLE_NEARBY_SEARCH_REQUESTED";
export const GET_GOOGLE_NEARBY_SEARCH_SUCCESS = "GET_GOOGLE_NEARBY_SEARCH_SUCCESS";
export const GET_GOOGLE_NEARBY_SEARCH_FAILED = "GET_GOOGLE_NEARBY_SEARCH_FAILED"

//Google Map Place details
export const GET_GOOGLE_MAP_PLACE_DETAILS = "GET_GOOGLE_MAP_PLACE_DETAILS";
export const GET_GOOGLE_MAP_PLACE_DETAILS_REQUESTED = "GET_GOOGLE_MAP_PLACE_DETAILS_REQUESTED";
export const GET_GOOGLE_MAP_PLACE_DETAILS_SUCCESS = "GET_GOOGLE_MAP_PLACE_DETAILS_SUCCESS";
export const GET_GOOGLE_MAP_PLACE_DETAILS_PICKUP_SUCCESS = "GET_GOOGLE_MAP_PLACE_DETAILS_PICKUP_SUCCESS";
export const GET_GOOGLE_MAP_PLACE_DETAILS_DROP_SUCCESS = "GET_GOOGLE_MAP_PLACE_DETAILS_DROP_SUCCESS";
export const GET_GOOGLE_MAP_PLACE_DETAILS_FAILED = "GET_GOOGLE_MAP_PLACE_DETAILS_FAILED"

//Google Map Direction details
export const GET_GOOGLE_MAP_DIRECTION_DETAILS = "GET_GOOGLE_MAP_DIRECTION_DETAILS";
export const GET_GOOGLE_MAP_DIRECTION_REQUESTED = "GET_GOOGLE_MAP_DIRECTION_REQUESTED";
export const GET_GOOGLE_MAP_DIRECTION_SUCCESS = "GET_GOOGLE_MAP_DIRECTION_SUCCESS";
export const GET_GOOGLE_MAP_DIRECTION_FAILED = "GET_GOOGLE_MAP_DIRECTION_FAILED";

//Google Map Geocode details
export const GET_GEOCODE = "GET_GEOCODE";
export const GET_GEOCODE_REQUESTED = "GET_GEOCODE_REQUESTED";
export const GET_GEOCODE_SUCCESS = "GET_GEOCODE_SUCCESS";
export const GET_GEOCODE_FAILED = "GET_GEOCODE_FAILED";

//Rate Calculation
export const GET_RATE_CALCULATION = "GET_RATE_CALCULATION";
export const GET_RATE_CALCULATION_REQUESTED = "GET_RATE_CALCULATION_REQUESTED";
export const GET_RATE_CALCULATION_SUCCESS = "GET_RATE_CALCULATION_SUCCESS";
export const GET_RATE_CALCULATION_FAILED = "GET_RATE_CALCULATION_FAILED";

//Profile
// export const GET_PROFILE = "GET_PROFILE";
// export const GET_PROFILE_REQUESTED = "GET_PROFILE_REQUESTED";
// export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
// export const GET_PROFILE_FAILED = "GET_PROFILE_FAILED";

//Update Profile
// export const GET_UPDATEPROFILE = "GET_UPDATEPROFILE";
// export const GET_UPDATEPROFILE_REQUESTED = "GET_UPDATEPROFILE_REQUESTED";
// export const GET_UPDATEPROFILE_SUCCESS = "GET_UPDATEPROFILE_SUCCESS";
// export const GET_UPDATEPROFILE_FAILED = "GET_UPDATEPROFILE_FAILED";

//Verify Profile
export const GET_VERIFY_PROFILE = "GET_VERIFY_PROFILE";
export const GET_VERIFY_PROFILE_REQUESTED = "GET-VERIFY_PROFILE_REQUESTED";
export const GET_VERIFY_PROFILE_SUCCESS = "GET_VERIFY_PROFILE_SUCCESS";
export const GET_VERIFY_PROFILE_FAILED = "GET_VERIFY_PROFILE_FAILED";

//Trip Checkout
export const GET_TRIP_CHECKOUT = "GET_TRIP_CHECKOUT";
export const GET_TRIP_CHECKOUT_REQUESTED = "GET_TRIP_CHECKOUT_REQUESTED";
export const GET_TRIP_CHECKOUT_SUCCESS = "GET_TRIP_CHECKOUT_SUCCESS";
export const GET_TRIP_CHECKOUT_FAILED = "GET_TRIP_CHECKOUT_FAILED";

//Verify Payment
export const GET_PAYMENT_VERIFY = "GET_PAYMENT_VERIFY";
export const GET_PAYMENT_VERIFY_REQUESTED = "GET_PAYMENT_VERIFY_REQUESTED";
export const GET_PAYMENT_VERIFY_SUCCESS = "GET_PAYMENT_VERIFY_SUCCESS";
export const GET_PAYMENT_VERIFY_FAILED = "GET_PAYMENT_VERIFY_FAILED";

//Hash Payment
export const GET_PAYMENT_HASHED = "GET_PAYMENT_HASHED";
export const GET_PAYMENT_HASHED_REQUESTED ="GET_PAYMENT_HASHED_REQUESTED";
export const GET_PAYMENT_HASHED_SUCCESS = "GET_PAYMENT_HASHED_SUCCESS";
export const GET_PAYMENT_HASHED_FAILED = "GET_PAYMENT_HASHED_FAILED";

//PayU 
export const GET_PAYU = "GET_PAYU";
export const GET_PAYU_REQUESTED = "GET_PAYU_REQUESTED";
export const GET_PAYU_SUCCESS = "GET_PAYU_SUCCESS";
export const GET_PAYU_FAILED = "GET_PAYU_FAILED";

//PayU 
export const GET_PAYU_RESPONSE = "GET_PAYU_RESPONSE";
export const GET_PAYU_RESPONSE_REQUESTED = "GET_PAYU_RESPONSE_REQUESTED";
export const GET_PAYU_RESPONSE_SUCCESS = "GET_PAYU_RESPONSE_SUCCESS";
export const GET_PAYU_RESPONSE_FAILED = "GET_PAYU_RESPONSE_FAILED";

//Airport 
export const GET_TRIP_SLAB = "GET_TRIP_SLAB";
export const GET_TRIP_SLAB_REQUESTED = "GET_TRIP_SLAB_REQUESTED";
export const GET_TRIP_SLAB_SUCCESS = "GET_TRIP_SLAB_SUCCESS";
export const GET_TRIP_SLAB_FAILED = "GET_TRIP_SLAB_FAILED";

//CancelTrip
// export const GET_CANCEL_TRIP = "GET_CANCEL_TRIP";
// export const GET_CANCEL_TRIP_REQUESTED = "GET_CANCEL_TRIP_REQUESTED";
// export const GET_CANCEL_TRIP_SUCCESS ="GET_CANCEL_TRIP_SUCCESS";
// export const GET_CANCEL_TRIP_FAILED ="GET_CANCEL_TRIP_FAILED";

//CancelReason
export const GET_CANCEL_REASON = "GET_CANCEL_REASON";
export const GET_CANCEL_REASON_REQUESTED = "GET_CANCEL_REASON_REQUESTED";
export const GET_CANCEL_REASON_SUCCESS="GET_CANCEL_REASON_SUCCESS";
export const GET_CANCEL_REASON_FAILED="GET_CANCEL_REASON_FAILED";

//TripCompletion
export const GET_TRIP_COMPLETION = "GET_TRIP_COMPLETION";
export const GET_TRIP_COMPLETION_REQUESTED = "GET_TRIP_COMPLETION_REQUESTED";
export const GET_TRIP_COMPLETION_SUCCESS = "GET_TRIP_COMPLETION_SUCCESS";
export const GET_TRIP_COMPLETION_FAILED = "GET_TRIP_COMPLETION_FAILED";

//RefundPrices
export const GET_REFUND_PRICE = "GET_REFUND_PRICE";
export const GET_REFUND_PRICE_REQUESTED = "GET_REFUND_PRICE_REQUESTED";
export const GET_REFUND_PRICE_SUCCESS = "GET_REFUND_PRICE_SUCCESS";
export const GET_REFUND_PRICE_FAILED = "GET_REFUND_PRICE_FAILED";

//Rental Slab 
export const GET_RENATAL_SLAB = "GET_RENATAL_SLAB";
export const GET_RENATAL_SLAB_REQUESTED = "GET_RENATAL_SLAB_REQUESTED";
export const GET_RENATAL_SLAB_SUCCESS = "GET_RENATAL_SLAB_SUCCESS";
export const GET_RENATAL_SLAB_FAILED = "GET_RENATAL_SLAB_FAILED";
 
//Loader
// export const LOADER = {
//     LOADER_TRIGGER: "loader-trigger",
//     LOADER_SHOW: "loader-show"
// };

//cashfree 
export const GET_CASHFREE = "GET_CASHFREE";
export const GET_CASHFREE_REQUESTED = "GET_CASHFREE_REQUESTED";
export const GET_CASHFREE_SUCCESS = "GET_CASHFREE_SUCCESS";
export const GET_CASHFREE_FAILED = "GET_CASHFREE_FAILED";

//Verify Cashfree
export const GET_CASHFREE_VERIFY = "GET_CASHFREE_VERIFY";
export const GET_CASHFREE_VERIFY_REQUESTED = "GET_CASHFREE_VERIFY_REQUESTED";
export const GET_CASHFREE_VERIFY_SUCCESS = "GET_CASHFREE_VERIFY_SUCCESS";
export const GET_CASHFREE_VERIFY_FAILED = "GET_CASHFREE_VERIFY_FAILED";

// Clear reducer 
export const GET_CLEAR_AUTOCOMPLETE = "GET_CLEAR_AUTOCOMPLETE";
export const GET_CLEAR_RATE_CALCULATION = "GET_CLEAR_RATE_CALCULATION";
export const GET_CLEAR_DIRECTION = "GET_CLEAR_DIRECTION";

// Payment Method
export const GET_PAYMENT_METHOD = "GET_PAYMENT_METHOD";
export const GET_PAYMENT_METHOD_REQUESTED = "GET_PAYMENT_METHOD_REQUESTED";
export const GET_PAYMENT_METHOD_SUCCESS = "GET_PAYMENT_METHOD_SUCCESS";
export const GET_PAYMENT_METHOD_FAILED = "GET_PAYMENT_METHOD_FAILED";

//Coupon List
export const GET_COUPON_LIST = "GET_COUPON_LIST";
export const GET_COUPON_LIST_REQUESTED = "GET_COUPON_LIST_REQUESTED";
export const GET_COUPON_LIST_SUCCESS ="GET_COUPON_LIST_SUCCESS";
export const GET_COUPON_LIST_FAILED ="GET_COUPON_LIST_FAILED";

//Apply Coupon List
export const GET_APPLY_COUPON = "GET_APPLY_COUPON";
export const GET_APPLY_COUPON_REQUESTED = "GET_APPLY_COUPON_REQUESTED";
export const GET_APPLY_COUPON_SUCCESS ="GET_APPLY_COUPON_SUCCESS";
export const GET_APPLY_COUPON_FAILED ="GET_APPLY_COUPON_FAILED";
export const GET_APPLY_COUPON_CLEAR = "GET_APPLY_COUPON_CLEAR";

//Apply Coupon Rental
export const GET_APPLY_COUPON_RENTAL = "GET_APPLY_COUPON_RENTAL";
export const GET_APPLY_COUPON_RENTAL_REQUESTED = "GET_APPLY_COUPON_RENTAL_REQUESTED";
export const GET_APPLY_COUPON_RENTAL_SUCCESS ="GET_APPLY_COUPON_RENTAL_SUCCESS";
export const GET_APPLY_COUPON_RENTAL_FAILED ="GET_APPLY_COUPON_RENTAL_FAILED";
export const GET_APPLY_COUPON_RENTAL_CLEAR = "GET_APPLY_COUPON_RENTAL_CLEAR";

//Location Check
export const GET_LOCATIONCHECK = "GET_LOCATIONCHECK";
export const GET_LOCATIONCHECK_REQUESTED = "GET_LOCATIONCHECK_REQUESTED";
export const GET_LOCATIONCHECK_SUCCESS = "GET_LOCATIONCHECK_SUCCESS";
export const GET_LOCATIONCHECK_FAILED = "GET_LOCATIONCHECK_FAILED";
export const GET_LOCATIONCHECK_CLEAR = "GET_LOCATIONCHECK_CLEAR";